import React from 'react'
import "./css/404.css";

function Error() {
  return (
    <div className='error'>
        <div className='error-msg'>
            <h1>Error 404</h1>
            <p>This page doesnt exsist, go back <a href="/home">home</a></p>
        </div>
    </div>
  )
}

export default Error